import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getTeamSaga(action: types.GetTeamActionType) {
  try {
    const response = yield call(services.getTeamService, action.payload);
    yield put({ type: actions.GET_TEAM_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_TEAM_ERROR, response: error });
    toastr.error("Team Not Found", `${error.error.message}`);
  }
}

export function* getTeamsSaga(action: types.GetTeamsActionType) {
  try {
    const response = yield call(services.getTeamsService, action.payload);
    yield put({ type: actions.GET_TEAMS_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_TEAMS_ERROR, response: error });
    toastr.error("Teams Not Found", `${error.error.message}`);
  }
}

export function* addTeamSaga(action: types.AddTeamActionType) {
  try {
    const addResponse = yield call(services.addTeamService, action.payload);
    const getResponse = yield call(services.getTeamsService);
    if (addResponse.data) {
      yield put({ type: actions.ADD_TEAM_SUCCESS, response: addResponse });
      yield put({ type: actions.GET_TEAMS_SUCCESS, response: getResponse });
      toastr.success("Team Created", `Added '${action.payload.body.name}'`);
    } else {
      throw addResponse;
    }
  } catch (error) {
    yield put({ type: actions.ADD_TEAM_ERROR, response: error });
    toastr.error("Team Not Created", `${error.error.message}`);
  }
}

export function* modifyTeamSaga(action: types.ModifyTeamActionType) {
  try {
    const modifyResponse = yield call(
      services.modifyTeamService,
      action.payload
    );
    const getResponse = yield call(services.getTeamsService);
    if (modifyResponse.data) {
      yield put({
        type: actions.MODIFY_TEAM_SUCCESS,
        response: modifyResponse,
      });
      yield put({ type: actions.GET_TEAMS_SUCCESS, response: getResponse });
      toastr.success("Team Modified", `Modified '${action.payload.body.name}'`);
    } else {
      throw modifyResponse;
    }
  } catch (error) {
    yield put({ type: actions.MODIFY_TEAM_ERROR, response: error });
    toastr.error("Team Not Modified", `${error.error.message}`);
  }
}

export function* deleteTeamSaga(action: types.DeleteTeamActionType) {
  try {
    const deleteResponse = yield call(
      services.deleteTeamService,
      action.payload
    );
    const getResponse = yield call(services.getTeamsService);
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_TEAM_SUCCESS,
        response: deleteResponse,
      });
      yield put({ type: actions.GET_TEAMS_SUCCESS, response: getResponse });
      toastr.success("Team Deleted", `All dependencies removed`);
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    yield put({ type: actions.DELETE_TEAM_ERROR, response: error });
    toastr.error("Team Not Deleted", `${error.error.message}`);
  }
}

export function* getTeamUsersSaga(action: types.GetTeamUsersActionType) {
  try {
    const response = yield call(services.getTeamUsersService, action.payload);
    if (response.data) {
      yield put({ type: actions.GET_TEAM_USERS_SUCCESS, response });
    } else {
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.GET_TEAMS_ERROR, response: error });
    toastr.error("Team Users Not Loaded", `${error.error.message}`);
  }
}

export function* addTeamUserSaga(action: types.AddTeamUserActionType) {
  try {
    const addResponse = yield call(services.addTeamUserService, action.payload);
    const getResponse = yield call(services.getTeamUsersService);
    if (addResponse.data) {
      yield put({ type: actions.ADD_TEAM_USER_SUCCESS, response: addResponse });
      yield put({
        type: actions.GET_TEAM_USERS_SUCCESS,
        response: getResponse,
      });
      toastr.success("User Added to Team", `Success`);
    } else {
      throw addResponse;
    }
  } catch (error) {
    yield put({ type: actions.ADD_TEAM_USER_ERROR, response: error });
    toastr.error("User Not Added to Team", `${error.error.message}`);
  }
}

export function* deleteTeamUserSaga(action: types.DeleteTeamUserActionType) {
  try {
    const deleteResponse = yield call(
      services.deleteTeamUserService,
      action.payload
    );
    const getResponse = yield call(services.getTeamUsersService);
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_TEAM_USER_SUCCESS,
        response: deleteResponse,
      });
      yield put({
        type: actions.GET_TEAM_USERS_SUCCESS,
        response: getResponse,
      });
      toastr.success("User Removed from Team", `Success`);
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    yield put({ type: actions.DELETE_TEAM_USER_ERROR, response: error });
    toastr.error("User Not Removed from Team", `${error.error.message}`);
  }
}
